
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { isIE } from '../../helpers/checkBrowser';
import { logout } from '../../subjects/logout';

@Component
export default class BrowserValidate extends BaseComponent {
  mounted() {
    this.validarBrowser();
  }

  public validarBrowser(): void {
    if (!isIE()) {
      return;
    }

    const action = () => {
      logout();
    };

    logout();
    let msg =
      'Informamos que o navegador Internet Explorer foi descontinuado pelo seu fabricante, ';
    msg +=
      ' não sendo possível a utilização do sistema ParenteralNet5 por esse navegador.';
    this.dialog.show(
      'alert',
      'Atenção!',
      msg,
      'OK',
      null,
      null,
      null,
      null,
      '500px',
    );
  }
}
